import { SvgIcon, SvgIconProps } from '@mui/material';

const SandTimerOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="SandTimerOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 2C19.5523 2 20 2.44772 20 3C20 3.55228 19.5523 4 19 4H17.5V7.5C17.5 9.36102 16.5747 11.0048 15.1602 12C16.5747 12.9952 17.5 14.639 17.5 16.5V20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21C4 20.4477 4.44772 20 5 20H6.5V16.5C6.5 14.6393 7.42466 12.9953 8.83887 12C7.42466 11.0047 6.5 9.36073 6.5 7.5V4H5C4.44772 4 4 3.55228 4 3C4 2.44772 4.44772 2 5 2H19ZM12 13C10.067 13 8.5 14.567 8.5 16.5V20H15.5V16.5C15.5 14.567 13.933 13 12 13ZM8.5 7.5C8.5 9.433 10.067 11 12 11C13.933 11 15.5 9.433 15.5 7.5V4H8.5V7.5Z"
      />
    </SvgIcon>
  );
};

export default SandTimerOutlined;
